import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class PinService {
  private dialogId;
  showPinDialog$ = new BehaviorSubject<boolean>(null);
  showWitnessPinDialog$ = new BehaviorSubject<boolean>(null);
  showResetPinDialog$ = new BehaviorSubject<boolean>(null);
  validatePin$ = new BehaviorSubject<{success: boolean, pin: number, dialogId: any, response?: any}>(null);
  focusPin: boolean;
  

  closeDialog() {
    this.showPinDialog$.next(false);
    this.showWitnessPinDialog$.next(false);
    this.focusPin = false;
    this.validatePin$.next(null);
  }

  openResetPinDialog(): void {
    this.showPinDialog$.next(false);
    this.focusPin = false;
    this.showResetPinDialog$.next(true);
  }

  closeResetPinDialog(): void {
    this.showResetPinDialog$.next(false);
    this.showPinDialog$.next(true);
    setTimeout(() => (this.focusPin = true));
  }

  afterPinUpdated(success: boolean): void {
    if (success) {
      this.closeResetPinDialog();
    }
  }

  validatePin({success, pin, response}): void {
    this.validatePin$.next({success, pin, dialogId: this.dialogId, response})
  }

  setDialogId(dialogId: any): void {
    this.dialogId = dialogId;
  }

  openPinDialog(channel: string): void {
    this.setDialogId(channel);
    this.showPinDialog$.next(true);
  }

  openWitnessDialog(channel: string): void {
    this.setDialogId(channel);
    this.showWitnessPinDialog$.next(true);
  }
}